import { useEffect, useState } from "react";
import { toast } from "sonner";
import { prod, saveBlob } from "@/lib/prodApi";
import { PrintRoot, collectCss } from "@/components/production/printKit";

const wait = () => new Promise((r) => requestAnimationFrame(() => requestAnimationFrame(r)));

// Renders assets off-screen, then prints them (window.print) or turns them into a server-side PDF.
export function usePrintJob() {
  const [job, setJob] = useState(null);
  useEffect(() => {
    if (!job) return;
    (async () => {
      await document.fonts.ready;
      await wait();
      const root = document.getElementById("print-root");
      if (job.mode === "print") {
        const done = () => { document.body.classList.remove("printing"); window.removeEventListener("afterprint", done); setJob(null); };
        window.addEventListener("afterprint", done);
        document.body.classList.add("printing");
        window.print();
        return;
      }
      try {
        const { data } = await prod.post("/pdf", { title: job.title, html: root.innerHTML, css: collectCss() }, { responseType: "blob" });
        saveBlob(data, `SPORE_${job.file}.pdf`);
        toast.success(`${job.title}: PDF downloaded`);
      } catch (e) {
        toast.error("The PDF could not be produced. Try again.");
      } finally {
        setJob(null);
      }
    })();
  }, [job]);
  const start = (mode, assets, title, file) => setJob({ mode, assets, title, file: file || title.replace(/[^A-Za-z0-9]+/g, "_") });
  return { job, start, root: job ? <PrintRoot assets={job.assets} /> : null };
}
